import { MutableRefObject } from "react";

export const manualEndCallRef = { current: false };

export const startNextCallRef: MutableRefObject<(() => void) | undefined> = {
  current: undefined,
};
